import { useState } from 'react';
import { Alert, AlertTitle, Snackbar as MuiSnackbar } from '@mui/material';
import { SystemIcon } from '@monorepo/nova-icons';
import { SnackbarMessage } from './types';

interface SnackbarProps {
  snackbar: SnackbarMessage;
  onClose: (id: string) => void;
  anchorOrigin: {
    vertical: 'top' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
  };
  style?: React.CSSProperties;
}

export const SnackbarComponent: React.FC<SnackbarProps> = ({
  snackbar,
  onClose,
  anchorOrigin,
  style,
}) => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  const handleExited = () => {
    onClose(snackbar.id);
  };
  const getIcon = () => {
    switch (snackbar.severity) {
      case 'success':
        return <SystemIcon iconName="Check" />;
      case 'error':
        return <SystemIcon iconName="SealWarning" />;
      case 'info':
        return <SystemIcon iconName="SealQuestion" />;
      default:
        return <SystemIcon iconName="SealQuestion" />;
    }
  };

  const getBorderColor = () => {
    switch (snackbar.severity) {
      case 'success':
        return 'success.main';
      case 'error':
        return 'error.main';
      case 'info':
        return 'background.contrast';
      default:
        return 'error.main';
    }
  };

  const getAction = () => {
    if (snackbar.action) {
      return snackbar.action;
    }

    return undefined;
  };
  return (
    <MuiSnackbar
      open={open}
      anchorOrigin={anchorOrigin}
      autoHideDuration={snackbar.autoHideDuration}
      onClose={handleClose}
      slotProps={{ transition: { onExited: handleExited } }}
      style={style}
    >
      <Alert
        variant={snackbar.variant}
        severity={snackbar.severity}
        icon={getIcon()}
        action={getAction()}
        sx={{
          width: '100%',
          border: '1px solid',
          borderColor: getBorderColor(),
        }}
      >
        {snackbar.title && <AlertTitle>{snackbar.title}</AlertTitle>}
        {snackbar.message}
      </Alert>
    </MuiSnackbar>
  );
};
